import { EditableRegion } from "../core/form/EditableRegion";
import { useData, useDataValue } from "../core/hooks/useData";
import { InfoElement, usePresenter } from "./types";

export function Info(props: {
	def: InfoElement,
}) {
	const presenter = usePresenter();
	const data = useData();
	const value = useDataValue(data, props.def.id);

	if (presenter.designMode) {
		return (
			<EditableRegion
				className={props.def.className}
				intialHtml={props.def.html ? props.def.html : ""}
				onChange={(e) => {
					props.def.html = e.target.value;
				}}
			/>
		);

	} else {

		// is there some html to display?
		let html = props.def.html;
		if (html) {
			if (html.indexOf("{value}") >= 0) {
				html = html.replace("{value}", value);
			}
			return (
				<div dangerouslySetInnerHTML={{ __html: props.def.html }} className={props.def.className} />
			);

		} else {
			// if we don't have static text to display then display whatever value is available
			return <div className={props.def.className}>{value}</div>;

		}



	}
}